var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-carousel",
    { attrs: { cycle: "", height: "auto" } },
    _vm._l(_vm.items, function (item, i) {
      return _c(
        "v-carousel-item",
        { key: i, attrs: { eager: "" } },
        [
          _c("v-sheet", { attrs: { height: "100%" } }, [
            _c(
              "a",
              [
                _c("BaseImage", {
                  attrs: {
                    mobileSrc: item.mobileSrc,
                    desktopSrc: item.desktopSrc,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }